<template>
	<div class="app-tooltip">
		<slot></slot>
	</div>
</template>

<script>
export default {
	props: {
		horizontal: Boolean
	},

	mounted () {
		this.setPositionReference(this.$el)
	},

	methods: {
		setPositionReference (el) {
			if (!el) return
			const elementPosition = el.getBoundingClientRect()
			if (this.horizontal) {
				const isRight = window.innerWidth - elementPosition.left < elementPosition.left
				if (isRight) {
					el.classList.add('app-tooltip--right')
					el.classList.remove('app-tooltip---left')
				} else {
					el.classList.add('app-tooltip--left')
					el.classList.remove('app-tooltip--right')
				}
			} else {
				const isTop = window.innerHeight - elementPosition.top < elementPosition.top
				if (isTop) {
					el.classList.add('app-tooltip--top')
					el.classList.remove('app-tooltip--bottom')
				} else {
					el.classList.add('app-tooltip--bottom')
					el.classList.remove('app-tooltip--top')
				}
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.app-tooltip {
	position: absolute;
	pointer-events: none;
	background-color: $default;
	padding: 1em;
	border-radius: 3px;
	color: #fff;
	font-size: .8em;
	line-height: 1.3em;
	z-index: 99;
	text-align: center;
	width: 150px;

	&:after {
		content: '';
		display: inline-block;
		width: 0;
		height: 0;
		border: 10px solid;
		position: absolute;
	}

	&--bottom,
	&--top {
		left: 50%;
		transform: translateX(-50%);
		margin: 10px 0;
	}

	&--bottom {
		bottom: auto;
		top: 100%;

		&:after {
			border-color: transparent transparent $default transparent;
			bottom: 100%;
			left: calc(50% - 10px)
		}
	}

	&--top {
		top: auto;
		bottom: 100%;

		&:after {
			border-color: $default transparent transparent transparent;
			top: 100%;
			left: calc(50% - 10px)
		}
	}

	&--right,
	&--left {
		margin: 0 10px;
		top: 50%;
		transform: translateY(-50%);
	}

	&--right {
		left: auto;
		right: 100%;

		&:after {
			border-color: transparent transparent transparent $default;
			left: 100%;
			top: calc(50% - 10px)
		}
	}

	&--left {
		right: auto;
		left: 100%;

		&:after {
			border-color: transparent $default transparent transparent;
			right: 100%;
			top: calc(50% - 10px)
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/app-components/AppTooltip.vue